/**
 * **mockup 판정** — 「이 op 호출이 mockup 것인가」를 정하는 한 자리.
 *
 * 디스패처(`src/actions/firestore/dispatch.ts`)의 `resolveBackend` 와 ES 가로채기가 **같은 규칙**을 봐야 하므로
 * 판정을 여기 하나로 모은다. 규칙은 하나뿐이다 — **id 가 `MOCKUP_` 로 시작하면 mockup 이다.**
 *
 * ⚠️ 이 파일은 **픽스처도 백엔드도 물지 않는다.** 디스패처가 정적으로 물기 때문에,
 * 여기서 무언가를 import 하면 그것이 일반 번들에도 실린다. 순수 함수만 둔다.
 *
 * ⚠️ 실화면에는 `MOCKUP_` 로 시작하는 워크스페이스·캠페인 id 가 없다(운영·dev 실측 id 는
 * `WS####` · `{workspaceId}_{nanoid12}` 꼴이다). 그래서 mockup 백엔드가 등록돼 있어도
 * 실화면 호출은 한 건도 가로채지 않는다.
 */

export const MOCKUP_ID_PREFIX = 'MOCKUP_';

/** 문자열 하나가 mockup id 인가 */
export function isMockupId(value: unknown): boolean {
  return typeof value === 'string' && value.startsWith(MOCKUP_ID_PREFIX);
}

/**
 * params 가 id 를 나르는 칸들 — op 마다 이름이 다르다.
 * 새 op 를 덮으면 그 op 의 id 칸을 여기 더한다(빠뜨리면 조용히 real 로 간다).
 */
const MOCKUP_ID_FIELDS = [
  'workspaceId',
  'workspaceIds',
  'campaignId',
  'campaignIds',
  'id',
  'docId',
  /** Meta 광고 단건·유사 소재(`ads.detail` · `/api/meta-ads/similar`) */
  'adId',
  /** 맞춤 알림 규칙 고치기·켜고 끄기·지우기(`alertRule.update` · `.enabled.set` · `.delete`) */
  'ruleId',
] as const;

/** op params 어딘가에 mockup id 가 실려 있나 */
export function hasMockupId(params: unknown): boolean {
  if (params === null || typeof params !== 'object') return false;
  return MOCKUP_ID_FIELDS.some((field) => {
    if (!(field in params)) return false;
    const value = Reflect.get(params, field);
    if (isMockupId(value)) return true;
    return Array.isArray(value) && value.some(isMockupId);
  });
}
